import React, { useState } from 'react';
import { Tabs } from 'antd';
import OtherAcceptedPayments from './OtherAcceptedPayments';
import OtherCardTypes from './OtherCardTypes';
import OtherFeeTax from './OtherFeeTax';

const { TabPane } = Tabs;

const OtherPayments = (props: any) => {
  const [disabledFlag, setDisabledFlag] = useState<any>(false)

  const disableTabPanes = (value: Boolean) => {
    setDisabledFlag(value)
  }
  return (
    <div >
      <Tabs defaultActiveKey="1">
        <TabPane tab="Other Accepted Payments" key="1" disabled={disabledFlag}>
          <OtherAcceptedPayments isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
        </TabPane>
        <TabPane tab="Other Card Types" key="2" disabled={disabledFlag}>
          <OtherCardTypes isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
        </TabPane>
        <TabPane tab="Other Fee Tax" key="3" disabled={disabledFlag}>
          <OtherFeeTax isEditable={props.isEditable} cancelEditable={props.cancelEditable} disableTabPanes={disableTabPanes} />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default OtherPayments;

